import { supabase } from "./core.js";

const BUCKET = "extratos";
const ALLOWED_TYPES = [
  "application/pdf",
  "application/zip",
  "application/x-zip-compressed",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel", // .xls
  "text/csv", // .csv
  "application/csv",
  "application/x-ofx", // .ofx
  "text/x-ofx",
  "text/plain", // OFX files sometimes detected as text/plain
];
const MAX_SIZE = 50 * 1024 * 1024; // 50 MB — matches UI limit

interface UploadResult {
  path: string;
  fullPath: string;
}

export async function uploadExtrato(clientId: string, file: File): Promise<UploadResult> {
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error("Formato inválido. Aceitos: PDF, XLSX, CSV, OFX e ZIP.");
  }
  if (file.size > MAX_SIZE) {
    throw new Error("Arquivo muito grande. Máximo: 50 MB.");
  }

  const ext = file.name.split(".").pop() || "pdf";
  const path = `${clientId}/${Date.now()}.${ext}`;

  const { data, error } = await supabase.storage.from(BUCKET).upload(path, file, {
    cacheControl: "3600",
    upsert: false,
  });
  if (error) throw error;
  return { path, fullPath: data?.path || path };
}

interface ExtratoItem {
  name: string;
  id?: string;
  created_at?: string;
  metadata?: Record<string, unknown>;
}

export async function listClientExtratos(clientId: string): Promise<ExtratoItem[]> {
  const { data, error } = await supabase.storage.from(BUCKET).list(clientId, {
    sortBy: { column: "created_at", order: "desc" },
  });
  if (error) throw error;
  return (data || []) as ExtratoItem[];
}

export async function getExtratoSignedUrl(path: string): Promise<string> {
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, 3600);
  if (error) throw error;
  return data?.signedUrl || "";
}

export async function deleteExtrato(path: string): Promise<void> {
  const { error } = await supabase.storage.from(BUCKET).remove([path]);
  if (error) throw error;
}
